import React from 'react';
import isEmpty from 'lodash/isEmpty';
import findKey from 'lodash/findKey';

import TakeOver from 'Components/Banner/TakeOver';

const PreviewTakeOver = ({
  takeOver,
}) => {
  if (isEmpty(takeOver)) return false;

  const firstAppearsOn = findKey(takeOver.appears_on, value => value === true);

  return (
    <div className="PreviewTakeOver mr-0 ml-0 pr-0 pl-0 container" style={{ maxWidth: '100%' }}>
      <h1 className="pt-5 pl-5">Take Over Preview</h1>
      <div className="PreviewTakeOver__mobilePreviewContainer pt-5 pl-5">
        <h3>Mobile Banner</h3>
        <div className="PreviewTakeOver__mobilePreview" style={{ maxWidth: 576 }}>
          <TakeOver mobileOverride previewTakeOver={takeOver} appearsOn={firstAppearsOn} />
        </div>
      </div>
      <div className="PreviewTakeOver__desktopPreviewContainer">
        <h3 className="pl-5">Desktop Banner</h3>
        <TakeOver previewTakeOver={takeOver} appearsOn={firstAppearsOn} />
      </div>
    </div>
  );
};

export default PreviewTakeOver;
